import React, { useEffect, useState, useRef } from "react";
import "../index.css";
import { Button, TextareaAutosize } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import Typography from "@material-ui/core/Typography";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { makeStyles } from "@material-ui/core/styles";

import {
  Select,
  MenuItem,
  TextField,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Radio,
  Input,
} from "@material-ui/core";
import { useHistory, useLocation } from "react-router-dom";
import http from "../services/httpService";
import toast from "react-hot-toast";
import { prospectPath, searchFilter, handleSort } from "../utils/varialbles";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import handleValidation from "../utils/handleValidations";
import handleSubmitValidation from "../utils/handleSubmitValidation";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    paddingTop: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  submitButton: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(10),
  },
  gridDevider: {
    marginTop: theme.spacing(6),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  lableColor: {
    color: "#393939",
  },
  select: {
    height: 36,
    minWidth: 235,
  },
  mobileCode: {
    height: 36,
  },
  radio: {
    "&$checked": {
      color: "#57bf74",
    },
  },
  reviewButton: {
    borderRadius: "20px",
    border: "1px solid #2835D5",
    opacity: 1,
    textAlign: "right",
  },

  checked: {},
}));
function EditTicket() {
  let history = useHistory();
  let [lookupFile, setLookupFile] = useState(null);
  const fileInputRef = useRef(null);
  const location = useLocation();
  const myParms = location.state;
  const classes = useStyles();
  let form = {
    issue: "",
    reporter: "",
    id_no: "",
    description: "",
    assigned: "",
    issue_type: "",
    attachment: null,
    severity: "",
    status: "",
    satisfaction: "",
    comments: "",
  };
  const [formObject, setFromObject] = useState(form);
  // (formObject);
  const [questionner, setQuestionner] = useState([]);
  const validations = {
    issue: {
      conditions: {
        required: true,
      },
      message: "This Field is required!",
      valid: true,
      changed: false,
    },
    reporter: {
      conditions: {
        required: false,
      },
      message: "This Field is required!",
      valid: true,
      changed: false,
    },
    id_no: {
      conditions: {
        required: true,
      },
      message: "This Field is required!",
      valid: true,
      changed: false,
    },
    assigned: {
      conditions: {
        required: false,
      },
      message: "Maximum 20 character Allowed.!",
      valid: true,
      changed: false,
    },
    issue_type: {
      conditions: {
        required: false,
      },
      message: "Maximum 20 character Allowed.!",
      valid: true,
      changed: false,
    },
    severity: {
      conditions: {
        required: false,
      },
      message: "Maximum 20 character Allowed.!",
      valid: true,
      changed: false,
    },
    status: {
      conditions: {
        required: true,
      },
      message: "Maximum 20 character Allowed.!",
      valid: true,
      changed: false,
    },
    description: {
      conditions: {
        required: true,
        maxLength: 1000,
      },
      message: "Maximum 1000 character Allowed.!",
      valid: true,
      changed: false,
    },
    comments: {
      conditions: {
        required: false,
        maxLength: 1000,
      },
      message: "Maximum 1000 character Allowed.!",
      valid: false,
      changed: false,
    },

  };
  const [validationState, setValidationState] = useState(validations);
  const columns = [
    {
      value: "issue",
      imp: true,
      label: "Issue Title",
      minWidth: 170,
      filedType: "text",
      disabled: true,
    },
    {
      value: "reporter",
      imp: true,
      label: "Reported By",
      minWidth: 150,
      filedType: "dropDown",
      disabled: true,
    },
    {
      value: "attachment",
      imp: true,
      label: "Add Attachment",
      minWidth: 150,
      filedType: "file",
      disabled: true,
    },
    {
      value: "id_no",
      imp: true,
      label: "User ID",
      minWidth: 150,
      filedType: "text",
      disabled: true,
    },
    {
      value: "description",
      imp: true,
      label: "Decription",
      minWidth: 150,
      filedType: "textarea",
      multiline: true,
      rows: 3,
      disabled: true,
    },
    {
      value: "assigned",
      imp: true,
      label: "Assigned To",
      minWidth: 150,
      filedType: "dropDown",
      disabled: true,
    },
    {
      value: "issue_type",
      imp: true,
      label: "Issue Type",
      minWidth: 150,
      filedType: "dropDown",
      disabled: true,
    },
    {
      value: "severity",
      imp: true,
      label: "Severity",
      minWidth: 150,
      filedType: "dropDown",
      disabled: true,
    },
    {
      value: "status",
      imp: true,
      label: "Status",
      minWidth: 150,
      filedType: "dropDown",
    },
    {
      value: "satisfaction",
      imp: false,
      label: "Are you satisfied?",
      minWidth: 150,
      filedType: "dropDown",
      disabled: false,
    },
    {
      value: "comments",
      imp: false,
      label: "Comments",
      minWidth: 150,
      filedType: "textarea",
    },
  ];
  const getDropdownValue = (field, text, boolean, data) => {
    if (text) {
      let CurrentQuestion = columns.filter((obj) => {
        return obj["value"] === field;
      });
      let current = [];
      if (CurrentQuestion && CurrentQuestion.length > 0) {
        current = data.filter((obj) => {
          return obj["question"] === CurrentQuestion[0]["label"];
        });
      }
      if (boolean && text && text === true) {
        return 1;
      } else if (boolean && !text) {
        return 2;
      } else if (current && current.length > 0) {
        let value = current[0].options.filter((option) => {
          return option.name === text;
        });
        if (value.length > 0) {
          return value[0]["values"];
        } else {
          return "";
        }
      } else {
        return "";
      }
    } else {
      if (boolean && !text) {
        return 2;
      } else {
        return 1;
      }
    }
  };

  const [reprt, setreprt] = useState("");

  // const {report, assto, issuetypr, security}=setreprt;

  // (reprt);

  // setreprt({...reprt, report:reporter});

  useEffect(() => {
    if (myParms && myParms.id) {
      http
        .get("/updateticket/" + myParms.id)
        .then((response) => {
          if (
            response.data &&
            response.data.Dropdowns &&
            Array.isArray(response.data.Dropdowns) &&
            response.data.Dropdowns.length > 0
          ) {
            setQuestionner(response.data.Dropdowns);
          } else {
            // toast.error("Questioner Data Not Available for this investor..!");
            history.goBack();
          }
          if (
            response.data &&
            response.data.data &&
            Array.isArray(response.data.data) &&
            response.data.data.length > 0
          ) {
            let userData = response.data.data[0];
            setreprt(userData);
            let updatedForm = {
              issue: userData.issue,
              reporter: getDropdownValue(
                "reporter",
                userData.reporter,
                false,
                response.data.Dropdowns
              ),
              id_no: userData.id_no,
              comments: userData.comments,
              description: userData.description,
              assigned: getDropdownValue(
                "assigned",
                userData.assigned,
                false,
                response.data.Dropdowns
              ),
              issue_type: getDropdownValue(
                "issue_type",
                userData.issue_type,
                false,
                response.data.Dropdowns
              ),
              attachment: null,
              severity: getDropdownValue(
                "severity",
                userData.severity,
                false,
                response.data.Dropdowns
              ),
              status: getDropdownValue(
                "status",
                userData.status,
                false,
                response.data.Dropdowns
              ),
              satisfaction: getDropdownValue(
                "satisfaction",
                userData.satisfaction,
                false,
                response.data.Dropdowns
              ),
            };
            // (updatedForm);
            setFromObject(updatedForm);
          }
        })
        .catch((error) => {
          // toast.error("Questioner Data Not Available for this investor..!");
          gotoProspect();
        });
    } else {
      gotoProspect();
    }
  }, []);
  const handleChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    let valid = true;
    let validStateTemp = { ...validationState };
    if (name && validStateTemp.hasOwnProperty(name)) {
      let validation = handleValidation(name, value, validStateTemp);
      setValidationState(validation.validStateTemp);
      valid = validation.valid;
    }
    if (valid || value === "" || value == 0) {
      setFromObject({
        ...formObject,
        [event.target.name]: event.target.value,
      });
    }
  };
  const handleFileChange = (event) => {
    setLookupFile(event.target.files[0]);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    let validStateTemp = { ...validationState };
    let validCount = 0;
    let finalObjet = { ...formObject };

    let validData = handleSubmitValidation(finalObjet, validStateTemp);
    validCount = validData.validCount;
    if (validCount === 0) {
      if (myParms && myParms.id) {
        columns.map((obj) => {
          let filter = [];
          if ((obj["filedType"] = "dropDown")) {
            filter = questionner.filter((question) => {
              return question.question === obj.label;
            });
            if (filter.length > 0) {
              let value = filter[0].options.filter((option) => {
                return option.values === finalObjet[obj.value];
              });
              if (value.length > 0) {
                finalObjet[obj.value] = value[0]["name"];
              }
            }
          }
        });

        http
          .patch("/updateticket/" + myParms.id + "/", {
            status: finalObjet["status"],
            satisfaction: finalObjet["satisfaction"],
            comments: finalObjet["comments"],
          })
          .then((response) => {
            if (response.data.data && response.data.statusCode === 0) {
              // alert(1);
              // alert(2);
              // setFromObject(form)
              gotoProspect();
              toast.success(response.data.data);
              // alert(3);
            } else {
              toast.error(response.data.data);
            }
          })
          .catch((error) => {
            // alert(4);
            // (error);
            toast.error("Ticket Update Failed..!");
          });
        gotoProspect();
      } else {
        gotoProspect();
      }
    } else {
      setValidationState(validData.validStateTemp);
      toast.error("Please check Errors in Field level!");
    }
  };

  const gotoProspect = (e) => {
    // e.preventDefault();
    history.push({
      // state: {
      //   page: myParms.page,
      //   tab: "Ticket Manager",
      // },
      pathname: prospectPath,
    });

    // history.push({
    //     pathname: prospectPath, state: { "tab": "Ticket Manager" }
    // });
  };

  return (
    <Grid container component="main" className="pb30">
      <Grid item xs={12} sm={5} md={5} align="left" className={"overviewbar"}>
        <Button
          variant="outlined"
          color="default"
          startIcon={<ArrowBackIosIcon />}
          onClick={gotoProspect}
        >
          Back
        </Button>
      </Grid>
      <Grid item xs={12} sm={5} md={5} className={"overviewbar"}>
        <Typography color="textPrimary" variant="h5">
          View/Update Issue
        </Typography>
      </Grid>
      {columns.map((question) => {
        return (
          <Grid container className={classes.paper}>
            <Grid item xs={12} sm={2} md={2} className={"formLable"}>
              <InputLabel className={classes.lableColor} id={question.lable}>
                {question.label}
                {question.imp && (
                  <span
                    style={{
                      color: "red",
                      fontSize: "1.2rem",
                      marginLeft: "0.2rem",
                    }}
                  >
                    *
                  </span>
                )}
              </InputLabel>
            </Grid>
            <Grid item xs={12} lg={3} md={3} sm={3}>
              {question.filedType === "text" ? (
                <TextField
                  label="Enter"
                  variant="outlined"
                  value={formObject[question.value]}
                  name={question.value}
                  onChange={handleChange}
                  disabled={question.disabled}
                  style={
                    validationState.hasOwnProperty(question.value) &&
                      validationState[question.value]["changed"] &&
                      !validationState[question.value]["valid"]
                      ? { paddingBottom: 20, width: 335 }
                      : { width: 335 }
                  }
                  error={
                    validationState.hasOwnProperty(question.value) &&
                    validationState[question.value]["changed"] &&
                    !validationState[question.value]["valid"]
                  }
                  helperText={
                    validationState.hasOwnProperty(question.value) &&
                      validationState[question.value]["changed"] &&
                      !validationState[question.value]["valid"]
                      ? validationState[question.value]["message"]
                      : ""
                  }
                />
              ) : question.filedType === "radio" ? (
                <RadioGroup
                  row
                  aria-label="position"
                  name={question.value}
                  defaultValue="A"
                  value={
                    formObject[question.value]
                      ? formObject[question.value]
                      : "A"
                  }
                  onChange={handleChange}
                >
                  {question.options.map((option) => {
                    return (
                      <FormControlLabel
                        control={
                          <Radio
                            classes={{
                              root: classes.radio,
                              checked: classes.checked,
                            }}
                            value={option.value}
                          />
                        }
                        label={option.label}
                        labelPlacement="end"
                      />
                    );
                  })}
                </RadioGroup>
              ) : question.filedType === "file" ? (
                <>
                  <input
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    type="file"
                    style={{ display: "none" }}
                    multiple={false}
                    accept=".png,.PNG,.JPEG,.jpeg,.jpg,.JPG"
                  />
                  <Button
                    startIcon={<AddCircleOutlineIcon />}
                    variant="outlined"
                    className={classes.reviewButton}
                    color="primary"
                    onClick={() => fileInputRef.current.click()}
                    disabled={question.disabled}
                  >
                    Choose File
                  </Button>
                  <span style={{ marginLeft: 10 }}>
                    {lookupFile && lookupFile.name
                      ? lookupFile.name
                      : "No file chosen"}
                  </span>
                </>
              ) : question.filedType === "textarea" ? (
                <TextField
                  label="Enter"
                  variant="outlined"
                  value={formObject[question.value]}
                  name={question.value}
                  onChange={handleChange}
                  multiline
                  rows={question.rows}
                  disabled={question.disabled}
                  style={
                    validationState.hasOwnProperty(question.value) &&
                      validationState[question.value]["changed"] &&
                      !validationState[question.value]["valid"]
                      ? { paddingBottom: 20, width: 335 }
                      : { width: 335 }
                  }
                  error={
                    validationState.hasOwnProperty(question.value) &&
                    validationState[question.value]["changed"] &&
                    !validationState[question.value]["valid"]
                  }
                  helperText={
                    validationState.hasOwnProperty(question.value) &&
                      validationState[question.value]["changed"] &&
                      !validationState[question.value]["valid"]
                      ? validationState[question.value]["message"]
                      : `${formObject[question.value]
                        ? formObject[question.value].length
                        : 0
                      }/${validationState[question.value] &&
                      validationState[question.value]["conditions"][
                      "maxLength"
                      ]
                      }`
                  }
                />
              ) : question.filedType === "dropDown" ? (
                questionner
                  .filter((obj) => {
                    return obj.question === question.label;
                  })
                  .map((a) => {
                    return (
                      <>
                        <Select
                          displayEmpty
                          labelId="statusLable"
                          id="statusSelect"
                          variant="outlined"
                          className={classes.select}
                          onChange={handleChange}
                          value={
                            formObject[question.value]
                              ? formObject[question.value]
                              : ""
                          }
                          name={question.value}
                          disabled={question.disabled}
                          style={
                            validationState.hasOwnProperty(question.value) &&
                              validationState[question.value]["changed"] &&
                              !validationState[question.value]["valid"]
                              ? { paddingBottom: 20, width: 335 }
                              : { width: 335 }
                          }
                          error={
                            validationState.hasOwnProperty(question.value) &&
                            validationState[question.value]["changed"] &&
                            !validationState[question.value]["valid"]
                          }
                        >
                          <MenuItem value="">
                            {question.value === "reporter"
                              ? reprt.reporter
                              : question.value === "issue_type"
                                ? reprt.issue_type
                                : question.value === "severity"
                                  ? reprt.severity
                                  : question.value === "assigned"
                                    ? reprt.assigned
                                    : "select"}
                          </MenuItem>
                          {/* <MenuItem value="">select</MenuItem> */}
                          {a.options.map((option) => {
                            return (
                              <MenuItem
                                value={option.values}
                                key={option.values}
                              >
                                {option.name}
                              </MenuItem>
                            );
                          })}
                          )
                        </Select>

                        {validationState.hasOwnProperty(question.value) &&
                          validationState[question.value]["changed"] &&
                          !validationState[question.value]["valid"] ? (
                          <div
                            style={{
                              color: "#f44336",
                              fontSize: "0.75rem",
                              margin: "3px 14px",
                            }}
                          >
                            {validationState[question.value]["message"]}
                          </div>
                        ) : null}
                      </>
                    );
                  })
              ) : (
                ""
              )}
            </Grid>
          </Grid>
        );
      })}
      <Grid container className={(classes.submitButton, "prospectgrids")}>
        <Grid item xs={12} sm={2} md={2}></Grid>

        <Grid item xs={12} sm={2} md={2} className={"overviewbar"}>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Update Issue
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default EditTicket;
